import {appProfileTypes, deliveryTypes, orderTypes, paymentProviderTypes} from 'app/constant'
import {orderType, typesPayment} from '.'
import {getAppProfile} from 'app/utilities'
import toLowerCase from 'lodash/toLower'
import {PAYMENT_TYPES} from 'app/constant/payment'

export enum OrderEditType {
  edit = 'EDIT',
  refund = 'REFUND',
}

enum OrderTye {
  POS = 'POS',
  adminPortal = 'ADMIN_PORTAL',
  e_commerce = 'E_COMMERCE',
  wineClub = 'WINE_CLUB',
}

enum FinancialStatus {
  pending = 'PENDING',
  paid = 'PAID',
  partiallyPaid = 'PARTIALLY_PAID',
  refund = 'REFUNDED',
  partiallyRefunded = 'PARTIALLY_REFUNDED',
}

export type Transactions = {
  amount: number | any
  paymentType: string
  createdAt: string
  withoutTipAmount: number | any
  tipAmount: number | any
  terminalName: string
}

export type Customer = {
  id: string | null
  firstName: string | null
  lastName: string | null
  email: string | any
  phone: number | any
  shippingAddress: any
  billingAddress: any
  paymentMethod: any
  transactions: Transactions[]
  shippingPreferenceCompany: string
  customerName: string
}

type ShippingLabel = {
  url: any
  graphicImage: any
  encodedLabel: any
}

export type OrderItem = {
  id: string
  product: any
  productId: string
  variantId: string
  variant: string
  quantity: number
  price: number
  discountPrice: number
  totalPrice: number
  available: number
  fulfillableQuantity: number
  fulfilledQuantity: number
  refundedQuantity: number
  originalPrice: number
}

type FulfillmentItem = {
  id: string
  quantity: number
  orderItem: OrderItem
  orderItemId: String
}

type Fulfillment = {
  shippingLabels: {nodes: ShippingLabel[]}
  trackingUrl: any
  trackingCompanyName: any
  tracking: any
  fulfillmentItems: {nodes: FulfillmentItem[]}
}

interface OrderReadOnly {
  id: string
  name: string
  email: string
  phone: string
  createdAt: string
  createdUser: string
  orderNumber: number | any
  orderType: OrderTye | any
  customerId: string
  status: string
  shippingAddressId?: string | any
  billingAddressId: string | any
  orderDeliveryMethod: string
  subtotalPrice: number | any
  shippingPrice: number | any
  totalDiscounts: number | any
  wineClubDiscounts: number | any
  totalTax: number | any
  shippingRateId: string | any
  taxId: string
  totalPrice: number | any
  financialStatus: FinancialStatus | any
  fulfillmentStatus: string
  customer: Customer
  fulfillments: Fulfillment[]
  note?: string
  shippingRate: any
  orderItems: OrderItem[]
  orderHistory: any[]
  refundItems: any[]
  discounts: Record<string, any>
  notes: any[]
  fulfillmentLocationId: string
  tipAmount: any
  salesTax: number | any
  crv: number | any
  isCrvEnabled: boolean
  isPosEdit: boolean
  isAdminEnabledPosCancel: boolean
  invoiceNumber: number | any
  isDisableEdit: boolean
  hasWineClub: boolean
  paymentType?: string
  cardInfo: any
  freightSalesTax: number | any
  migratedOrderItems: any[]
  isAutoDiscountRemoved: boolean
  orderTrackings?: any[]
  isTaxRemoved: boolean
  isPosSplitOrder: boolean
  paymentProviderType?: string
  giftMessage?: any
  terminalName?: any
  isPaidByGiftCard: boolean
  isIncludedScannerTransaction: boolean
  paymentMethodId: string | any
  paymentToken?: string | any
}

export type ViewOrder = OrderReadOnly

export type Order = {
  id: string
  orderEditId: string | null
  shippingAddressId: string | any
  paymentMethodId: string | any
  billingAddressId: string | any
  orderDeliveryMethod: string
  subtotalPrice: number | any
  shippingPrice: number | any
  totalDiscounts: number | any
  wineClubDiscounts: number | any
  totalTax: number | any
  totalPrice: number | any
  wineClubDiscountCodeId: string | any
  discountCodeId: string | any
  freeShippingDiscountCodeId: string | any
  shippingRateId: string | any
  shippingRate: any
  shippingAddress: any
  paymentMethod: any
  billingAddress: any
  note: string | any
  isCompliant: boolean
  isFreeShipping: boolean
  isTaxRemoved: boolean
  isAutoDiscountRemoved: boolean
}

export type OrderState = {
  viewOrder: ViewOrder
  isFetching: boolean
}

export type Discount = {
  code: string | any
  name: string | any
  isWineClub: boolean
  isPromoCode: boolean
  discountCode: string | any
  freeShipCode: string | any
  discountCodeId: string | any
  promoCodeId: string | any
  wineClubCodeId: string | any
  isFreeShipping: boolean
  totalDiscounts: number | any
  wineClubDiscounts: number | any
  isCustomerAutoDiscount: boolean
  wineClubDiscountCodeId: string | any
  shippingDiscountCodeId: string | any
}

const initialState = {
  id: '',
  name: '',
  email: '',
  phone: '',
  createdAt: '',
  orderNumber: '',
  orderType: '',
  customerId: '',
  billingAddressId: '',
  orderDeliveryMethod: '',
  subtotalPrice: '',
  shippingPrice: '',
  totalDiscounts: '',
  wineClubDiscounts: '',
  shippingRateId: '',
  totalTax: '',
  taxId: '',
  totalPrice: '',
  financialStatus: '',
  fulfillmentStatus: '',
  isLoginOrder: false,
  customer: {
    id: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    shippingAddress: {},
    billingAddress: {},
    paymentMethod: {},
    transactions: [],
    shippingPreferenceCompany: '',
    customerName: '',
  },
  fulfillments: [],
  shippingRate: {},
  orderItems: [],
  orderHistory: [],
  refundItems: [],
  discounts: {},
  notes: [],
  salesTax: 0,
  crv: 0,
  isCrvEnabled: false,
  isPosEdit: false,
  cardInfo: {},
  migratedOrderItems: [],
  isAutoDiscountRemoved: false,
  isTaxRemoved: false,
}

export const order: Order = {
  id: '',
  orderDeliveryMethod: '',
  subtotalPrice: '',
  shippingPrice: '',
  totalDiscounts: '',
  wineClubDiscounts: '',
  totalTax: '',
  shippingAddress: {},
  shippingRate: {},
  orderEditId: null,
  shippingAddressId: '',
  wineClubDiscountCodeId: '',
  freeShippingDiscountCodeId: '',
  discountCodeId: '',
  shippingRateId: '',
  note: '',
  isCompliant: true,
  isFreeShipping: false,
  totalPrice: function (): number {
    return (
      parseFloat(this.subtotalPrice) +
      parseFloat(this.totalTax) +
      parseFloat(this.shippingPrice) -
      parseFloat(this.totalDiscounts) -
      parseFloat(this.wineClubDiscounts)
    )
  },
  paymentMethodId: '',
  paymentMethod: {},
  billingAddress: {},
  billingAddressId: '',
  isTaxRemoved: false,
  isAutoDiscountRemoved: false,
}

export const viewOrder: ViewOrder = {
  ...initialState,
  status: '',
  fulfillmentLocationId: '',
  tipAmount: 0,
  freightSalesTax: 0,
  invoiceNumber: '',
  isDisableEdit: false,
  hasWineClub: false,
  isAdminEnabledPosCancel: false,
  isTaxRemoved: false,
  createdUser: '',
  isPosSplitOrder: false,
  paymentProviderType: '',
  giftMessage: null,
  isPaidByGiftCard: false,
  isIncludedScannerTransaction: false,
  paymentMethodId: null,
  paymentToken: null,
}

export const orderInitialState: OrderState = {
  isFetching: false,
  viewOrder,
}

export const isCashOrCheck = (paymentType: string | any) => {
  const methods = [toLowerCase(typesPayment.cash), toLowerCase(typesPayment.check)]
  return methods.includes(toLowerCase(paymentType))
}

export const isCheckEditForPaymentType = (order: ViewOrder) => {
  const isPayengine = order.paymentProviderType === paymentProviderTypes.payengine
  const isCard = toLowerCase(order.paymentType) === toLowerCase(PAYMENT_TYPES.creditCard)
  if (isCashOrCheck(order.paymentType)) {
    return true
  }
  if (order.orderType === orderTypes.WINE_CLUB) {
    return true
  }
  if (order.totalPrice > 0) {
    if (isCard && !isPayengine && order.paymentMethodId) {
      return true
    }
    if (isCard && isPayengine && (order.paymentMethodId || order.paymentToken)) {
      return true
    }
    return false
  }
  if (order.paymentType === PAYMENT_TYPES.scanner) {
    return false
  }
  return false
}

export const isDisableOrderEdit = (order: ViewOrder, isPosOrderEditEnabled: boolean) => {
  if (isPosOrderEditEnabled) {
    return isOrderEditPosEnabled(order)
  }
  if (
    order.isDisableEdit ||
    isCashOrCheck(order.paymentType) ||
    order.orderType === orderType.pos ||
    order.isPaidByGiftCard
  ) {
    return true
  }

  return false
}

export const isOrderEditPosEnabled = (order: ViewOrder) => {
  if (order.isDisableEdit || !isCheckEditForPaymentType(order) || order.isPaidByGiftCard) {
    return true
  }

  return false
}
